module.exports = __webpack_public_path__ + "static/media/retail_viejo.e1e60637.svg";